/** How long a phase runs as the board stands, in weeks: "a week", "3 weeks" (its card, and the Phases list). */
export const weeks = (d: number): string => {
  const n = Math.max(1, Math.round(d / 7));
  return n === 1 ? 'a week' : `${n} weeks`;
};
